import { parser } from './src/grammar';

const parse = (queryString) => {
    return parser.parse(queryString);
}

export default { parse }